import Screen from './screen';
import FinishCroudView from '../../../game/views/finishCroudView';

export default class FinishScreen extends Screen {
    #salutes;
    #finishCroudView;

    constructor(el) {
        super(el);

        this.#salutes = Array.from(this.el.querySelectorAll('.js-finish-salute'));
        this.#finishCroudView = new FinishCroudView('#finish-croud');
    }

    setIsActive(isActive, isPt) {
        if (isActive) {
            this.showSalutes();
            this.showCroud(isPt);
        } else {
            this.hideSalutes();
            this.hideCroud();
        }

        super.setIsActive(isActive);
    }

    showSalutes() {
        this.#salutes.forEach((salute) => {
            salute.classList.add('active');
        });
    }

    hideSalutes() {
        this.#salutes.forEach((salute) => {
            salute.classList.remove('active');
        });
    }

    showCroud(isPt) {
        this.#finishCroudView.show(isPt);
    }

    hideCroud() {
        this.#finishCroudView.hide();
    }
}
